module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gc-Ha-Ib-Jb.a8c3a50d.png";